import { Link } from "react-router-dom";
import type { ArticleItem } from "@/mocks/articles";

interface ArticleCardProps {
  article: ArticleItem;
  horizontal?: boolean;
}

export default function ArticleCard({ article, horizontal = false }: ArticleCardProps) {
  if (horizontal) {
    return (
      <article className="group flex flex-col sm:flex-row overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1 hover:border-primary-200">
        <Link to={`/article/${article.id}`} className="block sm:w-2/5 overflow-hidden" aria-label={`阅读文章：${article.title}`}>
          <img
            src={article.cover}
            alt={`${article.title} 配图`}
            title={`${article.title} 文章`}
            className="h-44 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 sm:h-full"
            loading="lazy"
          />
        </Link>
        <div className="flex flex-1 flex-col gap-2 p-4 md:p-5">
          <span className="w-fit rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-900">
            {article.category}
          </span>
          <h3 className="line-clamp-2 font-heading text-base text-foreground-950 md:text-lg">
            <Link to={`/article/${article.id}`} className="hover:text-primary-600 transition-colors">
              {article.title}
            </Link>
          </h3>
          <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
            {article.summary}
          </p>
          <div className="mt-auto flex items-center gap-3 pt-1 text-xs text-foreground-500">
            <span className="whitespace-nowrap">{article.date}</span>
            <span className="whitespace-nowrap">阅读约 {article.readTime} 分钟</span>
          </div>
        </div>
      </article>
    );
  }

  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1 hover:border-primary-200">
      <Link to={`/article/${article.id}`} className="relative block aspect-[16/10] w-full overflow-hidden" aria-label={`阅读文章：${article.title}`}>
        <img
          src={article.cover}
          alt={`${article.title} 配图`}
          title={`${article.title} 文章`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <span className="absolute left-2 top-2 rounded-full bg-background-950/70 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
          {article.category}
        </span>
      </Link>
      <div className="flex flex-1 flex-col gap-2 p-4 md:p-5">
        <h3 className="line-clamp-2 font-heading text-base text-foreground-950 md:text-lg">
          <Link to={`/article/${article.id}`} className="hover:text-primary-600 transition-colors">
            {article.title}
          </Link>
        </h3>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
          {article.summary}
        </p>
        <div className="mt-auto flex items-center gap-3 pt-1 text-xs text-foreground-500">
          <span className="whitespace-nowrap">{article.date}</span>
          <span className="whitespace-nowrap">约 {article.readTime} 分钟</span>
        </div>
      </div>
    </article>
  );
}